// src/utils/sportIcons.ts
export const sportIcons: Record<string, string> = {
  Football: require('../assets/Football-icon.png'),
  Baseball: require('../assets/Baseball-icon.png'),
  Basketball: require('../assets/Basketball-icon.png'),
  Hockey: require('../assets/Hockey-icon.png'),
  General: require('../assets/General-icon.png'),
  Tennis: require('../assets/Tennis-icon.png'),
  Golf: require('../assets/Golf-icon.png'),
  Soccer: require('../assets/Soccer-icon.png'),
};